import { Download } from "lucide-react";
import { toast } from "sonner";
import { download, errMsg, fmtDate } from "../lib/api";

const TONE = { PASS: "text-emerald-300", WARNING: "text-amber-300", ERROR: "text-red-400" };

export function OutputsList({ items, testid = "outputs-list" }) {
  if (!items.length) return <p className="text-sm text-slate-500" data-testid={`${testid}-empty`}>Nothing built yet.</p>;
  return (
    <div className="space-y-3" data-testid={testid}>
      {items.map((o) => (
        <div key={o.id} className="panel p-4" data-testid={`output-${o.id}`}>
          <div className="flex flex-wrap justify-between items-center gap-2">
            <div><p className="text-sm text-slate-200">{o.filename}</p><p className="text-[11px] text-slate-500">{fmtDate(o.created_at)} · {o.size < 1024 * 1024 ? `${Math.max(1, Math.round(o.size / 1024))} KB` : `${(o.size / 1024 / 1024).toFixed(1)} MB`} · <span className={TONE[o.report?.overall]}>{o.report?.overall}</span></p></div>
            <button onClick={() => download(`/edition-outputs/${o.id}/download`, o.filename).catch((e) => toast.error(errMsg(e)))} className="inline-flex items-center gap-1 text-xs border border-amber-500/40 px-3 py-1.5 rounded-md text-amber-100 hover:bg-amber-600 transition-colors" data-testid={`output-download-${o.id}`}><Download size={13} />Download</button>
          </div>
          <ul className="mt-2 space-y-0.5">{(o.report?.checks || []).map((c) => <li key={c.id} className="text-[11px] text-slate-400"><span className={TONE[c.status]}>{c.status}</span> · {c.label}{c.detail ? ` — ${c.detail}` : ""}</li>)}</ul>
        </div>
      ))}
    </div>
  );
}
